import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { AddCustomerNoteRequest } from "./customerNotesApi";
import { addCustomerNote } from "./customerNotesApi";
import { invalidateCustomerNotesQueries } from "./useCustomerNotes";

/** Adds a note to the customer and refreshes every cached view of the customer's notes. */
export const useAddCustomerNote = (customerId: string) => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const addNoteMutation = useMutation<void, unknown, AddCustomerNoteRequest>({
    mutationFn: (request) => addCustomerNote(customerId, request),
    onSuccess: async () => {
      enqueueSnackbar("Notatka została dodana", { variant: "success" });
      await invalidateCustomerNotesQueries(queryClient, customerId);
    },
  });

  return (request: AddCustomerNoteRequest) => addNoteMutation.mutateAsync(request);
};
